module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    attrs: {
      "type": "checkbox",
      "id": "nav-menu-full-checkbox"
    },
    domProps: {
      "checked": _vm.full
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-101cda8f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuFullstatehandler.vue
// module id = 450
// module chunks = 2